import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getAllOperatorReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/operators', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.operator,
    params: data
  })
}

export const getTopProfitReportsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/profit', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getAllPeriodicReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/periodic', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
